module.exports = __webpack_public_path__ + "58bb53ac2d4b0f89ef0acdece44448cd.png";